import ApplicationAdapter from './application';
import { isNone } from '@ember/utils';

export default class SubjectAdapter extends ApplicationAdapter {
  _insertActionIntoURL(url, actionId) {
    return url.replace('subjects', `actions/${actionId}/subjects`);
  }

  _getActionIdFromQuery(query) {
    if (!isNone(query) && !isNone(query.action_id)) {
      let { action_id: id } = query;
      return id;
    }
    return null;
  }

  buildURL(modelName, id, snapshot, requestType, query) {
    let actionId = this._getActionIdFromQuery(query);

    // Delete "action_id" value from query, so that it doesn't end up being added to the
    // URL as a query parameter.
    let queryToUse;
    if (query != null) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      let { action_id: _, ...queryWithoutActionId } = query;
      queryToUse = queryWithoutActionId;
    }
    let url = super.buildURL(modelName, id, snapshot, requestType, queryToUse);

    if (!actionId || requestType !== 'query') {
      return url;
    }

    return this._insertActionIntoURL(url, actionId);
  }
}
